import React from 'react';

import Dropzone from 'react-dropzone';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faUpload } from '@fortawesome/pro-solid-svg-icons';

// Mirrors MAX_UPLOAD_BYTES in PageLibraryPagesController so an oversized file is
// refused here, before it is sent.
export const MAX_UPLOAD_BYTES = 50 * 1024 * 1024;

export const DROP_REJECTED = "That file couldn't be used. Check it's a PDF under 50MB and try again.";

const DROP_ZONE_CLASS =
  'd-flex flex-column align-items-center justify-content-center p-5 border border-2 border-dashed rounded';

interface Props {
  busy: boolean;
  // Shown in place of the prompt while busy, when the caller has something to say.
  busyLabel?: string;
  hint: string;
  prompt: React.ReactNode;
  onDrop: (files: File[]) => void;
  onDropRejected: () => void;
}

// The PDF picker both the upload and replace flows share: one file, PDF only,
// under the server's size cap. attr-accept matches ".pdf" on the filename, which
// covers PDFs the browser labels octet-stream or leaves untyped.
export default function PdfDropzone({ busy, busyLabel, hint, prompt, onDrop, onDropRejected }: Props) {
  const label = busy && busyLabel ? busyLabel : prompt;

  return (
    <Dropzone
      accept=".pdf,application/pdf"
      disabled={busy}
      maxSize={MAX_UPLOAD_BYTES}
      multiple={false}
      onDrop={onDrop}
      onDropRejected={onDropRejected}
    >
      {({ getRootProps, getInputProps }) => (
        <div className={DROP_ZONE_CLASS} style={{ cursor: 'pointer' }} {...getRootProps()}>
          <input {...getInputProps()} type="file" />
          <FontAwesomeIcon className="text-primary mb-3" icon={faUpload} size="xl" />
          <span>{label}</span>
          <span className="text-muted mt-1">{hint}</span>
        </div>
      )}
    </Dropzone>
  );
}
